var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('footer',{staticClass:"footer bg-custom"},[_c('small',{staticClass:"footer-text"},[_vm._v(" Corendon Airlines © "+_vm._s(new Date().getFullYear())+" - All Rights Reserved."),_c('br')])])])
}
var staticRenderFns = []

export { render, staticRenderFns }